module.exports = __webpack_public_path__ + "815a4efc.png";